import { translate } from "app/filters/i18nFilter";
import {
    StyledTooltipBody,
    StyledTooltipHeader,
    StyledTooltipTitle,
} from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/shared/SignalsTooltipContent/styles";

const IntentSignalsEventsTooltipContainer = ({ children }: { children: React.ReactNode }) => (
    <>
        <StyledTooltipHeader>
            <StyledTooltipTitle>{translate(`si.signals.company-overview.tooltip.title.intent`)}</StyledTooltipTitle>
        </StyledTooltipHeader>

        <StyledTooltipBody>{children}</StyledTooltipBody>
    </>
);

export default IntentSignalsEventsTooltipContainer;
